// extracted by mini-css-extract-plugin
export default {"recos":"X6-z","productCardOverride":"Y6-z","rowHasBadge":"Z6-z"};